<template>
  <div class="DkProductManager">
    <h3 class="my-4">DK-Produkte</h3>

    <b-button
      variant="outline-primary"
      :to="{ name: 'product-new'}">
    <i class="material-icons">add</i>Produkt hinzufügen</b-button>

    <b-card>
      <b-container class="bv-highlighted-row">
        <b-row class="whiteRow">
          <b-col align-self="center" cols="6" md="4" sm="3">
            Name
          </b-col>
          <b-col align-self="center" cols="6" md="3" sm="3">
            Preis
          </b-col>
          <b-col align-self="center" cols="6" md="3" sm="3">
            Link
          </b-col>
          <b-col cols="6" md="2" sm="3">
          </b-col>
        </b-row>
        <b-row
          v-for="(product, index) in products"
          :key="product.slug"
          v-bind:class="{ whiteRow: index%2 }">
          <b-col cols="6" md="4" sm="3">
            {{product.name}}
          </b-col>
          <b-col cols="6" md="3" sm="3">
            {{toLocaleString(product.price)}}
          </b-col>
          <b-col cols="6" md="3" sm="3">
            <a :href="product.link" target="_blank">DK-Link</a>
          </b-col>
          <b-col cols="6" md="2" sm="3">
            <b-button-group size="sm">
              <b-button
                size="sm"
                block
                variant="outline-primary"
                v-on:click="editProduct(index)"
                v-b-tooltip.hover
                title="Produkt bearbeiten">
                <i class="material-icons">edit</i>
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>
      </b-container>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_PRODUCTS
} from "@/store/actions.type";

export default {
  title: "DK-Produkte verwalten | So wird's gemacht",
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters(["products"])
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.$store.dispatch(FETCH_PRODUCTS);
    },
    editProduct(index) {
      var slug = this.products[index].slug
      this.$router.push({ name: "product-edit", params: {"slug": slug}});
    },
    toLocaleString(price) {
      if (price) {
        return price.toLocaleString('de-DE', {minimumFractionDigits: 2})
      } else {
        return " - "
      }
    },
  }
}
</script>

<style lang="scss">
.DkProductManager {
  width: 100%;
  .bv-highlighted-row {
    .row>.col-6 {
      padding: 10px 15px;
    }
    .row>.col, .row>.col-2, .row>.col-3, .row>.col-4, .row>.col-5, .row>.col-6 {
      border: 1px solid rgba(86,61,124,.2);
    }
    .row {
      background-color: rgba(0, 0, 0, 0.05);
    }
    .row.whiteRow {
      background-color: rgba(0, 0, 0, 0.02);
    }
  }
}
</style>
